import React from 'react'
import './Subheader.css'
import MenuIcon from '@mui/icons-material/Menu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Link } from 'react-router-dom';
export default function Subheader() {
    return (
        <div className='headers'>
            <div className="headers_nav">
                <Link to="/">
            <div className="headers_basket">
                    <MenuIcon  className="shoppingcart"/>
                    <span className ="headers_optionLineone"> All</span>
                </div>
                </Link>
                <Link  to ="/mobiles">
               <div className ="headers_option">
                   <span className ="headers_optionLineone"> Mobiles  </span>
                  
               </div> 
               </Link>
               <Link  to ="/">
               <div className ="headers_option">
                   <span className ="headers_optionLineone"> Best Sellers  </span>
                   
                </div> 
                </Link>
                <Link to ="/electronics">
                <div className ="headers_option">
                   <span className ="headers_optionLineone"> Electronics </span>
                   
                </div>
                </Link> 
                <Link to ="/fashion">
                <div className ="headers_option">
                   <span className ="headers_optionLineone"> Fashion </span>
                   
                </div>
                </Link>
                
                <div className ="headers_option">
                   <span className ="headers_optionLineone"> Customer Service </span>
                   
                </div>  
           
                
                <div className ="headers_option">
                   <span className ="headers_optionLineone"> Home & Kitchen </span>
                   
                </div>  
                <div className ="headers_option">
                   <span className ="headers_optionLineone"> Computers</span>              
                </div>  
                <Link to ="/prime">
                <div className ="headers_basket">
            
                   <span className ="headers_optionLineone"> Prime</span> 
                   <ArrowDropDownIcon  className="shoppingcart"/> 
                            
                </div> 
                </Link>

                <div className ="headers_option">
                   <span className ="headers_optionLineone"> Today's Deal </span>
                </div>  
        
            </div>
        </div>
    )
}
